module.exports = __webpack_public_path__ + "static/media/18.cfceb763.jpg";